import { render, staticRenderFns } from "./BrowseStrategiesFilters.vue?vue&type=template&id=be985340&scoped=true"
import script from "./BrowseStrategiesFilters.vue?vue&type=script&lang=js"
export * from "./BrowseStrategiesFilters.vue?vue&type=script&lang=js"
import style0 from "./BrowseStrategiesFilters.vue?vue&type=style&index=0&id=be985340&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be985340",
  null
  
)

export default component.exports